import { SITE } from '../constants/site';

const region = () => {
  const language = navigator.language.split('-');
  if (language.length === 1) {
    return language;
  }
  return language[language.length - 1];
};

const systemLanguageCode = () => {
  if (navigator.language && fullSystemLanguageCode()) {
    return fullSystemLanguageCode();
  }
  return 'en';
};

const fullSystemLanguageCode = () => {
  const languages = navigator.languages;
  if (!languages) {
    if (navigator.language) {
      return navigator.language;
    }
    return navigator.userLanguage; // ie
  }

  // priority for tw langs
  const twLanguages = SITE.tw.languages;
  const hasTwLang = languages.find(lang =>
    twLanguages.includes(lang.toLowerCase()),
  );

  if (hasTwLang) {
    return SITE.tw.defaultLang;
  }

  const language = languages[0].toLowerCase();
  const matchSupportedSite = Object.values(SITE).find(site =>
    site.languages.includes(language),
  );

  if (matchSupportedSite) {
    return matchSupportedSite.defaultLang;
  }

  return 'en';
};

const languageCodeForPoiBank = () => {
  const language = fullSystemLanguageCode();
  return language.replace('-', '_');
};

const verifyLanguageQueryString = string => {
  if (!string) {
    return false;
  }
  if (string.length === 0) {
    return false;
  }

  // only support en,zh,ja,ko now
  const code = string.split('-')[0];
  const lowerCaseCode = code ? code.toLowerCase() : string.toLowerCase();
  if (
    lowerCaseCode === 'en' ||
    lowerCaseCode === 'zh' ||
    lowerCaseCode === 'ja' ||
    lowerCaseCode === 'ko'
  ) {
    return true;
  }
  return false;
};

const getUserName = (firstName, lastName) => {
  if (!firstName || !lastName) {
    return `${firstName} ${lastName}`;
  }
  if (
    firstName.match(
      /[\u3040-\u30ff\u3400-\u4dbf\u4e00-\u9fff\uf900-\ufaff\uff66-\uff9f]/,
    )
  ) {
    return `${lastName} ${firstName}`;
  }
  return `${firstName} ${lastName}`;
};

export {
  systemLanguageCode,
  fullSystemLanguageCode,
  languageCodeForPoiBank,
  region,
  verifyLanguageQueryString,
  getUserName,
};
